import React from 'react';
import { BMI, age } from '../simpleFunctions';
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';

const override = css`
display: block;
margin: 0 auto;
border-color: red;
`;

const PatientInfo = (props) => {
  // Use: extract the form object to populate the patient info card on the patient home page
  const values = props.questionnaire.DTTParsedResponse !== undefined ? props.questionnaire.DTTParsedResponse : null;
  const response = !(props.questionnaire.fetching) !== undefined ? !(props.questionnaire.fetching) : null;


  return (
    <div className="patientinfo">
      <h1>Patient Info</h1>
      {values ? (
        <div className="personalinfo">
          <React.Fragment >
            <div className="name">Name: {values.A1 ? values.A1 : 'N/A'}</div>
            <div className="patient-divider" />
            <div style={{ textAlign: 'left' }}>MRN: {values.A2 ? values.A2 : 'N/A'}</div>
            <div style={{ textAlign: 'left' }}>Date of Birth: {values.A3 ? values.A3 : 'N/A'}</div>
            <div style={{ textAlign: 'left' }}>Gender: {values.A4 ? values.A4.display : 'N/A'}</div>
            <div style={{ textAlign: 'left' }}>Current Age: {values.A3 ? age(values.A3, 'DD-MM-YYYY') : 'N/A'}</div>
            <div style={{ textAlign: 'left' }}>Primary Diagnosis: {values.A7 ? values.A7 : 'N/A'}</div>
            <div style={{ textAlign: 'left' }}>Age of Diagnosis: {values.A6 ? values.A6 : 'N/A'}</div>
            <div style={{ textAlign: 'left' }}>Body Mass Index: {values.K119 && values.K120 ? BMI(values.K119, values.K120) : 'N/A'}</div>
          </React.Fragment>
        </div>
      ) : (!response ?
        <div>
          <BeatLoader
            css={override}
            sizeUnit="px"
            size={30}
            color="#41AAD9"
          />
        </div>
        :
        <div>Please fill in the first page of the questionnaire.</div>
      )}
    </div>
  );
};

export default PatientInfo;



// WEBPACK FOOTER //
// ./src/components/PatientHome/PatientInfo.js